<template>
  <v-container class="no-p" fluid>
    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
    </v-app-bar>

    <h2 class="general-title-app mt-5 mb-2">Sucursales</h2>

    <div class="new-list-of-packages" v-if="items.length > 0">
      <v-list three-line>
        <template v-for="(item, index) in items">
          <template class="item-conteiner">
            <div class="pb-2">
              <v-list-item :key="index">
                <v-list-item-content>
                  <div class="new-list-of-packages__item-content pb-3">
                    <img
                      style="width:60px;height:60px;"
                      src="@/assets/location-item.png"
                      :alt="item.oficina"
                    />

                    <div class="new-list-of-packages__genearl-info">
                      <div class="detail__text" style="color:#929DB1;">
                        {{ item.oficina }}
                      </div>
                      <div
                        v-bind:class="
                          item.longitud !== '' && item.latitud !== ''
                            ? ' mb-3'
                            : 'has-btn '
                        "
                      >
                        <div class="detail__text" v-if="item.telefono1 !== ''">
                          <b>Teléfono : </b> {{ item.telefono1 }}
                        </div>
                      </div>
                    </div>
                    <div>
                      <v-btn
                        class="dots-btn"
                        :loading="loading"
                        :disabled="loading"
                        @click="detailsContentAction(item)"
                      >
                        <span></span>
                        <span></span>
                        <span></span>
                      </v-btn>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <div
                class="btn-status text-left px-2"
                v-if="parseInt(item.mostrar_boton) == 0"
              >
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  small
                  block
                  color="secondary"
                  class
                  @click="pickFile(item.trackingnumber, item.id_prealerta)"
                >
                  {{ language.upload_invoice }}

                  <!-- <v-icon right dark>cloud_upload</v-icon> -->
                </v-btn>
              </div>
            </div>
          </template>
        </template>
      </v-list>
    </div>

    <div v-else>
      <div v-if="noData">
        <img src="../assets/nodatos.jpg" class="noData" alt />
        <div class="font-weight-black text-center">
          NO TIENES DATOS DISPONIBLES
        </div>
      </div>
      <v-progress-circular
        :size="90"
        color="blue"
        indeterminate
        class="loading-center"
      ></v-progress-circular>
    </div>

    <v-dialog v-model="dialog_details" width="500">
      <template> </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ language.details }}
        </v-card-title>

        <v-card-text>
          <v-simple-table v-if="detailsContent != null">
            <template v-slot:default>
              <tbody>
                <tr>
                  <th colspan="2">Dirección</th>
                </tr>
                <tr>
                  <td colspan="2">
                    <v-list-tile-sub-title class="mt-3 no-hidden-text">{{
                      detailsContent.direccion
                    }}</v-list-tile-sub-title>
                  </td>
                </tr>
                <tr v-if="detailsContent.sector != ''">
                  <th>Sector</th>
                  <td>{{ detailsContent.sector }}</td>
                </tr>
                <tr v-if="detailsContent.email_address !== ''">
                  <th>Email</th>
                  <td>{{ detailsContent.email_address }}</td>
                </tr>
                <tr v-if="detailsContent.telefono1 !== ''">
                  <th>Teléfono</th>
                  <td>{{ detailsContent.telefono1 }}</td>
                </tr>
                <tr v-if="detailsContent.telefono2 !== ''">
                  <th>Teléfono</th>
                  <td>{{ detailsContent.telefono2 }}</td>
                </tr>
                <tr v-if="detailsContent.horario !== ''">
                  <th>Horario</th>
                  <td>{{ detailsContent.horario }}</td>
                </tr>
                <tr v-if="detailsContent.instagram != ''">
                  <th>Instagram</th>
                  <td>{{ detailsContent.instagram }}</td>
                </tr>
                <tr v-if="detailsContent.facebook != ''">
                  <th>Facebook</th>
                  <td>{{ detailsContent.facebook }}</td>
                </tr>
                <tr v-if="detailsContent.twiiter">
                  <th>Twitter</th>
                  <td>{{ detailsContent.twiiter }}</td>
                </tr>
                <tr v-if="detailsContent.website != ''">
                  <th>Website</th>
                  <td>{{ detailsContent.website }}</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <v-btn
                      color="info"
                      class="mb-3 mt-1"
                      block
                      v-if="
                        detailsContent.longitud !== '' &&
                          detailsContent.latitud !== ''
                      "
                      @click="
                        openMap(
                          detailsContent.longitud,
                          detailsContent.latitud,
                          detailsContent.oficina
                        )
                      "
                      >Ver en el mapa</v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="detailsContentClose">
            {{ language.close }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="mainDrawerNav" v-if="drawer" absolute bottom temporary>
      <div>
        <v-btn icon @click="drawer = !drawer">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </div>
      <div class="mainDrawerNav__user" to="/profile">
        <img src="@/assets/user_login.png" alt="logo" />

        <div class="user__content" v-if="profile.length > 0">
          <h2 class="user__name" v-if="profile[0].nombre != ''">
            Hola, {{ profile[0].nombre }}
          </h2>
          <p class="user__local" v-if="profile[0].descripcion_oficina != ''">
            {{ profile[0].descripcion_oficina }}
          </p>
        </div>
      </div>
      <div class="mb-2 mt-2">
        <v-btn
          :loading="loading"
          :disabled="loading"
          large
          block
          color="secondary"
          class
          @click="logOut"
        >
          Cerrar Sección
        </v-btn>
      </div>

      <v-list nav dense>
        <v-list-item-group v-model="group">
          <v-list-item to="/home">
            <v-list-item-title><img src="" alt="" />Paquetes</v-list-item-title>
          </v-list-item>

          <v-list-item to="/prealert">
            <v-list-item-title
              ><img src="" alt="" />Pre-alerta</v-list-item-title
            >
          </v-list-item>

          <v-list-item to="/office">
            <v-list-item-title
              ><img src="" alt="" />Sucursales</v-list-item-title
            >
          </v-list-item>

          <v-list-item to="/help">
            <v-list-item-title><img src="" alt="" />Ayuda</v-list-item-title>
          </v-list-item>

          <v-list-item to="/profile">
            <v-list-item-title><img src="" alt="" />Perfil</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </v-container>
</template>

<script>
// import Helpers from "../utils/helpers";
import Server from "../utils/server";
export default {
  created() {
    this.$store.watch(
      (state, getters) => getters.user,
      // (newValue, oldValue) => {
      (newValue) => {
        console.log(newValue);
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if (this.currentUser != undefined) {
            console.log(this.currentUser);
            this.getPacks();
          }
        }
      }
    );
  },
  mounted() {
    if (this.currentUser != undefined) {
      this.getPacks();
    } else if (this.user.userName != null) {
      this.currentUser = this.user;
      this.getPacks();
    }
  },
  data() {
    return {
      clipped: false,
      items: [],
      currentUser: undefined,
      dialog_details: false,
      detailsContent: null,
      drawer: false,
      group: null,
    };
  },
  computed: {
    login: function() {
      return this.$store.getters.login;
    },
    user: function() {
      return this.$store.getters.user;
    },
    language: function() {
      return this.$store.getters.language;
    },
    profile: function() {
      return this.$store.getters.profile;
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch("logout");
      window.MobileApi.signOut();

      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$http.post(Server.logout, formData).then(
        // response => {},
        () => {},
        () => {}
      );
    },
    detailsContentAction(details) {
      this.dialog_details = true;
      this.detailsContent = details;
    },
    detailsContentClose() {
      this.dialog_details = false;
      this.detailsContent = null;
    },
    openMap(log, lat, title) {
      window.MobileApi.openLocationInMap(log, lat, title);
    },
    getPacks() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$http.post(Server.office, formData).then(
        (response) => {
          if (response.body.resultado !== "NO") {
            this.items = response.body;
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = "Try again later";
        }
      );
    },
  },
  name: "App",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
